export const LANG_STORAGE_KEY = 'lulpay.lang';

export function readStoredLanguage(value: string | null): 'en' | 'lg' | 'sw' {
  if (value === 'en' || value === 'lg' || value === 'sw') {
    return value;
  }
  return 'en';
}
